export const DOMAIN_URL = `http://${window.location.hostname}:3000`;

// export const RESTFULL_API_URL = `http://localhost:6500`;
export const RESTFULL_API_URL = `https://inside-111-testing.medpro.com.vn`;
// export const RESTFULL_API_URL = `https://api-v2.medpro.com.vn:5000`;

// export const MEDPRO_LOGIN = `http://localhost:9999/check-phone`;
// export const MEDPRO_LOGIN = `https://id-testing.medpro.com.vn/login`;
export const MEDPRO_LOGIN = `https://id-testing.medpro.com.vn/check-phone`; // medpro-id v1.2
// export const MEDPRO_LOGIN = `https://id-v110.medpro.com.vn/login`;

export const STATIC_CONTENT_API_URL = `https://static-inside-testing.medpro.com.vn`;
export const COOKIE_EXPIRES = 43200; // 12*60*60; // 12 tiếng

export const SOCKET_CHAT = "wss://socket.pkh.vn/cable";

export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";
